export class PrioritizationLog {
    lastPrioritizedBy?: string;
    lastPrioritizedDate?: Date;

    public constructor(data?: PrioritizationLog) {
        this.lastPrioritizedBy = data?.lastPrioritizedBy;
        this.lastPrioritizedDate = data?.lastPrioritizedDate;
    }
}
